import { Backdrop, BackdropProps } from "@material-ui/core";
import React, { useContext, useState } from "react";
import ContainerDimensions from "react-container-dimensions";
import { Shimmer } from "react-shimmer";
import { ReferralAppContext } from "../ReferralApp";
import { IReferralInfo, IReferralSettingsInfo } from "../ReferralInfo";
import ReferralPromocodeBenefitRow from "../ReferralPromocodeBenefitRow";
import { ReferralSteps } from "../steps/ReferralSteps";
import "./ReferralCabinetInfoSection.css";
import styles from "./ReferralCabinetInfoSection.module.css";

interface IReferralInfoSectionProps {
    referral?: IReferralInfo
    settings: IReferralSettingsInfo
}

export default function ReferralCabinetInfoSection({ referral, settings, isMobile }: { referral?: IReferralInfo, settings: IReferralSettingsInfo, isMobile: boolean }) {
    const [props, setProps] = useState<IReferralInfoSectionProps>({ referral: referral, settings: settings });

    const appContext = useContext(ReferralAppContext);
    const session = appContext?.session;
    const isRegistered = session?.user.is_registred ?? false;
    const hasPlus = session?.user.plus?.is_activated ?? false;

    if (props != null) {
        let myBenefits = props.settings.my_benefits.map((benefit, index) => {
            return <ReferralInfoWhyShareItem
                key={benefit.title + benefit.info + index}
                title={benefit.title}
                subtitle={benefit.info}
                backgroundImage={benefit.background}
            />
        })

        let othersBenefits = props.settings.other_benefits.map((benefit, index) => {
            return <div key={benefit.title + benefit.info + index} style={{ paddingBottom: "12px" }}>
                <ReferralPromocodeBenefitRow
                    icon={benefit.icon}
                    title={benefit.title}
                    subtitle={benefit.info}
                    isMobile={isMobile}
                />
            </div>
        })

        const hasReferral = props.referral?.has_referral ?? false;

        var promocodeTitle = "";
        if (hasReferral && props.referral?.code != null) {
            if (isRegistered) {
                promocodeTitle = "Ваш личный промокод";
            } else {
                promocodeTitle = "Промокод у вас есть, пусть вы и не в Драйве";
            }
        }

        var yourBenefitsTitle = "";
        if (hasPlus) {
            yourBenefitsTitle = "На что вам баллы Плюса";
        } else {
            yourBenefitsTitle = "На что вам баллы Плюса, если включите его";
        }

        if (isMobile) {
            return <div className="Referral_screen_info_section_mobile" key={props.referral?.code}>
                <ReferralSteps plusEnabled={hasPlus} isMobile={true} />

                <span className="Referral_screen_info_section_header_mobile">{yourBenefitsTitle}</span>

                <div className="Referral_screen_info_section_why_share_container_mobile">
                    <div className="Referral_screen_info_section_why_share_mobile">
                        {myBenefits}
                    </div>
                </div>

                <span style={{ paddingTop: "64px" }} className="Referral_screen_info_section_header_mobile">А друзьям что</span>
                {othersBenefits}
                <div style={{ paddingBottom: "38px" }} />
            </div>
        } else {
            return <div className="Referral_screen_info_section" key={props.referral?.code}>
                <div className={styles.steps_container}>
                    <ReferralSteps plusEnabled={hasPlus} isMobile={false} />
                </div>

                <span className="Referral_screen_info_section_header">{yourBenefitsTitle}</span>

                <div className="Referral_screen_info_section_why_share_container">
                    <div className="Referral_screen_info_section_why_share">
                        {myBenefits}
                    </div>
                </div>

                <span className="Referral_screen_info_section_header">А друзьям что</span>
                {othersBenefits}
                <div style={{ paddingBottom: "97px" }} />
            </div>
        }
    } else {
        if (isMobile) {
            return <ReferralInfoMobileLoader />
        } else {
            return <ReferralInfoLoader />
        }
    }
}

function ReferralInfoLoader() {
    return <div style={{ paddingBottom: "122px" }} className="Referral_screen_info_section">
        <Shimmer className="Referral_screen_info_section_loader_1" width={175} height={23} />
        <Shimmer className="Referral_screen_info_section_loader_2" width={1060} height={308} />
        <Shimmer className="Referral_screen_info_section_loader_3" width={329} height={23} />
        <Shimmer className="Referral_screen_info_section_loader_4" width={1060} height={135} />
        <Shimmer className="Referral_screen_info_section_loader_4" width={1060} height={135} />
    </div>
}

function ReferralInfoMobileLoader() {
    return <ContainerDimensions>
        {({ width, height }) =>
            <div style={{ paddingBottom: "122px", display: "flex", flexDirection: "column", alignItems: "stretch", paddingTop: "80px" }}>
                <Shimmer className="Referral_screen_info_section_mobile_loader_1" width={147} height={22} />
                <Shimmer className="Referral_screen_info_section_mobile_loader_2" width={width - 32} height={308} />
                <Shimmer className="Referral_screen_info_section_mobile_loader_3" width={147} height={22} />
                <Shimmer className="Referral_screen_info_section_mobile_loader_4" width={width - 32} height={135} />
                <Shimmer className="Referral_screen_info_section_mobile_loader_4" width={width - 32} height={135} />
            </div>
        }
    </ContainerDimensions>
}

interface IReferralInfoWhyShareItemProps {
    backgroundImage: string
    title: string
    subtitle: string
}

function ReferralInfoWhyShareItem(props: IReferralInfoWhyShareItemProps) {
    return <div style={{ backgroundImage: `url(${props.backgroundImage})`, backgroundSize: "contain" }} className="Referral_screen_info_section_why_share_item">
        <span className="Referral_screen_info_section_why_share_item_title">{props.title}</span>
        <span className="Referral_screen_info_section_why_share_item_subtitle">{props.subtitle}</span>
    </div>
}

export class BackDropIOSWorkaround extends React.PureComponent<BackdropProps> {
    protected onTouchMove(event: React.TouchEvent<HTMLDivElement>): void {
        event.preventDefault();
    }

    public render(): JSX.Element {
        return (
            <Backdrop {...this.props} onTouchMove={this.onTouchMove} />
        );
    }
}